import Logger from "pineer";

const logger = new Logger();

export default logger;
